// extracted by mini-css-extract-plugin
export var backupIcon = "_sl-1";
export var image = "_sl-0";